module.exports = {
          srcSet: __webpack_public_path__ + "0c4510a48a078f57378ee74a85953779-211.png"+" 211w",
          images:[ {path: __webpack_public_path__ + "0c4510a48a078f57378ee74a85953779-211.png",width: 211,height: 211}],
          src: __webpack_public_path__ + "0c4510a48a078f57378ee74a85953779-211.png",
          toString:function(){return __webpack_public_path__ + "0c4510a48a078f57378ee74a85953779-211.png"},
          
          width: 211,
          height: 211
        }